export enum ClientTypesEnum {
    Organization = 'Business/Organization',
    Personal = 'Individual'
}
